/**
 * 资源管理相关
 */
import axios from "../../utils/axios";

// 添加评论监控
export function add(data) {
    return axios({
        url: "/admin/review/monitor/add",
        method: "POST",
        data: data
    });
}

// 评价监控列表
export function page_list(data) {
    return axios({
        url: "/admin/review/monitor/page_list",
        method: "POST",
        data: data
    });
}

// 删除评价监控
export function remove(data) {
    return axios({
        url: "/admin/review/monitor/remove",
        method: "POST",
        data: data
    });
}

// 监控评价的商品列表（外层列表）
export function product_aggressive_page_list(data) {
    return axios({
        url: "/admin/review/monitor/product_aggressive_page_list",
        method: "POST",
        data: data
    });
}

// 指定ASIN评价监控列表
export function product_review_page_list(data) {
    return axios({
        url: "/admin/review/monitor/product_review_page_list",
        method: "POST",
        data: data
    });
}

// 未分类的评价监控列表
export function not_aggregate_page_list(data) {
    return axios({
        url: "/admin/review/monitor/not_aggregate_page_list",
        method: "POST",
        data: data
    });
}

// 修改备注
export function remark(data) {
    return axios({
        url: "/admin/review/monitor/remark",
        method: "POST",
        data: data
    });
}
